export const initSummary = ( apartmentCard ) => {
	const summary = apartmentCard.querySelector( 'div.summary' );

	if ( !summary )
	{
		return;
	}

	const price = apartmentCard.querySelector( 'ul.info li.price' );

	window.addEventListener( 'scroll', () => {
		if ( price.getBoundingClientRect().bottom < 160 )
		{
			summary.classList.add( 'show' );
		}
		else
		{
			summary.classList.remove( 'show' );
		}
	} );
};